import { Component, Input, OnInit } from "@angular/core";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

import { Constants } from "../constants/gsfCalc-constants";
import { GSFReport } from "../GSF-report.service";
import { JsonService } from "../jsonService";
import { LanguageModel, PillarRouteState } from "../models";
import { ReportCalculateService } from "../service/report-calculate.service";
import { ReportDataService } from "../service/report-data.service";
import { ActivityDependencyService } from "../service/activity-dependency.service";

@Component({
  selector: "app-gsf-calc",
  templateUrl: "./gsf-calc.component.html",
  styleUrls: ["./gsf-calc.component.scss"],
})
export class GsfCalcComponent implements OnInit {
  @Input() dbCallFlag = true;

  public imageConfig;
  public language: any;
  public languages: LanguageModel[] = [
    { key: "eng", value: "ENGLISH" },
    { key: "chi", value: "CHINA" },
    { key: "spa", value: "SPANISH" },
  ];
  public name: string;
  public pageGsf = true;
  public publicCalculator = true;
  public previousSelectedTab = 0;
  public pageCdp = false;
  public pillars: any = [
    "energy",
    "nature",
    "waste",
    "packaging",
    "transportation",
    "productUse",
    "others",
  ];
  public reportSubmissionId = 83;
  public reportId = null;
  public selectedLangCode: string = null;
  private currentIndex: number;
  private modified = 0;
  private message: string;

  public formatedPillars: PillarRouteState[] = [];

  constructor( //nosonar
    public activityDependency: ActivityDependencyService,
    public reportDataService: ReportDataService,
    public route: ActivatedRoute,
    public report: GSFReport,
    public translate: TranslateService,
    private readonly calService: ReportCalculateService,
    private readonly jsonService: JsonService,
    private readonly snackbar: MatSnackBar,
    private readonly router: Router
  ) {
    this.translate = translate;

    translate.setDefaultLang(Constants.LANGUAGE);
  }

  ngOnInit() {
    this.initDependentConfig();
    if (this.route) {
      this.language = this.route.snapshot.params.lang;
      sessionStorage.setItem("language", this.language);
    }
    this.getReportService();
    this.initLanguageVersions();
    this.loadImageConfigFile();
    this.report.pillarsLength = this.pillars.length;
    this.formatePillars(this.pillars);
    this.report.setFormatedPillars(this.formatedPillars);
    this.router.navigate(["./", this.pillars[0]], {
      relativeTo: this.route,
    });

    window.scrollTo(0, 0);
  }

  private formatePillars(pillars: string[]) {
    this.formatedPillars = [];
    pillars.forEach((pillar, index) => {
      this.formatedPillars.push({
        id: index,
        name: pillar,
        displayName: pillar,
        nextPillarName: pillars[index + 1] ? pillars[index + 1] : null,
        previousPillarName: pillars[index - 1] ? pillars[index - 1] : null,
        iscomplete: false,
      });
    });
  }

  changeLanguage(slectedLang: string): void {
    const prelang = this.route.snapshot.params.lang;
    this.router.navigateByUrl(this.router.url.replace(prelang, slectedLang));
    setTimeout(() => location.reload(), 1000);
  }
  errorInPillar(errorFlag, pillarIndex): void {
    this.message = errorFlag;
    this.currentIndex = pillarIndex;
  }

  onmodifiedActivity(e): void {
    this.modified += e;
  }
  onImageClick(): void {
    this.modified += 1;
  }

  ForTabChange(event): void {
    if (event === Constants.TAB) {
      this.currentIndex = this.report._previousSelectedTab;
    }
  }

  openSnackBar(message, time): void {
    if (message != null && message.trim().length > 0) {
      this.snackbar.open(message, "OK", {
        duration: time,
      });
    }
  }
  getReportService(): void {
    if (this.language) {
      this.translate.use(this.language);
      this.reportDataService.Language = this.language;
    } else if (this.reportDataService.Language) {
      this.language = this.reportDataService.Language;
      this.translate.use(this.reportDataService.Language);
    } else if (sessionStorage.getItem("language") != null) {
      this.language = sessionStorage.getItem("language");
      this.translate.use(this.language);
      this.reportDataService.Language = this.language;
    }
  }

  private initLanguageVersions(): void {
    this.languages.forEach((langObj) => {
      this.translate.get(langObj.value).subscribe((label) => {
        langObj.value = label;
      });
    });
    this.selectedLangCode = this.route.snapshot.params.lang;
  }

  private initDependentConfig(): void {
    this.calService.getDependedQusConfigs().subscribe((dependedQusConfig) => {
      this.activityDependency.dependency = dependedQusConfig;
    });
  }

  private loadImageConfigFile(): void {
    this.jsonService.getImageConfigJson().subscribe((imageConfig) => {
      this.imageConfig = imageConfig;
    });
  }
}
